export default {"src":"/_next/static/media/retrieve.9ea3c86c.svg","height":284,"width":208,"blurWidth":0,"blurHeight":0};